import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { p16, typography } from '../../styles/typography';
import { ButtonHost } from '../button/button';

export const Copy = styled.div`
  ${p16}
  color: ${color('gray80')};
  text-align: left;
  margin-top: ${gutter(1)};
  padding-top: ${gutter(3)};
  p {
    ${p16}
  }
  h1 {
    ${typography.m32}
  }
  h2 {
    ${typography.m28}
  }
  h3 {
    ${typography.m24}
  }
  h4 {
    ${typography.m20}
  }
  h5 {
    ${typography.m20}
  }
  strong {
    font-weight: bold;
  }
  italic {
    font-style: italic;
  }
  a {
    color: #00253e;
    text-decoration: underline;
  }
  ul,
  ol {
    margin-left: 24px;
    margin-bottom: 16px;
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  li {
    margin: 8px 0;
  }
`;

export const Host = styled.div`
  height: calc(100vh - 74px - 16px);
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  flex: 1;
  padding-top: ${gutter(4)};
  padding-bottom: 52px;

  h2 {
    margin-bottom: 8px;
  }

  p {
    margin-bottom: ${gutter(3)};
  }
`;

export const CheckboxItem = styled.div`
  margin-bottom: ${gutter(2)};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${gutter(4)};

  ${ButtonHost} {
    flex: 1;
  }
  ${ButtonHost} + ${ButtonHost} {
    margin-left: ${gutter(2)};
  }
`;

export const Form = styled.form`
  padding-bottom: ${gutter(2)};
  a {
    color: ${color('blue60')};
  }
`;

export const Center = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  ${typography.fonts.mercury(32)}
  color: ${color('gray80')};
`;

export const Sticky = styled.div`
  position: sticky;
  padding-top: 20px;
  bottom: 0;
  background-color: ${color('white')};

  &:before {
    content: '';
    position: absolute;
    top: -52px;

    height: 52px;
    width: 100%;

    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 100%
    );
  }
`;
